import React from 'react'

const chartTypes = [
    {
        type: 'column',
        icon: 'fa-solid fa-chart-column',
        label: 'Column graph',
    },
    {
        type: 'bar',
        icon: 'fa-solid fa-chart-bar',
        label: 'Bar graph',
    },
    {
        type: 'line',
        icon: 'fa-solid fa-chart-line',
        label: 'Line graph',
    },
    {
        type: 'area',
        icon: 'fa-solid fa-chart-line',
        label: 'Area chart',
    },
    // {
    //     type: 'pie',
    //     icon: 'fa-light fa-chart-pie-simple',
    //     label: 'Pie chart',
    // },
]

const ChartSelector = ({ onChange, chartType }) => (
    <div className="chartSelector">
        {chartTypes.map(({ type, icon, label }) => (
            <div
                className={`chartType ${chartType === type ? 'selected' : ''}`}
                onClick={() => onChange(type)}
            >
                <i className={icon} />
                {label}
            </div>
        ))}
    </div>
)

export default ChartSelector
